import {
  postDuplicateRequest,
  postDuplicateResponse,
} from '@core-api/content/content/template/duplicate';
import { getRegionBySeriesId } from '@mentimeter/region';
import useSWRMutation from 'swr/mutation';
import { makeRequest } from './request-wrapper/make-request';

interface UseDuplicateTemplateParams {
  slideDeckPublicKey: string;
  tags: string[];
  trackContext: string;
}

export const useDuplicateTemplate = ({
  slideDeckPublicKey,
  tags,
  trackContext,
}: UseDuplicateTemplateParams) => {
  return useSWRMutation('/content/templates/duplicate', async () => {
    const templateRegion = getRegionBySeriesId(slideDeckPublicKey);
    const requestParams = {
      source: {
        region: templateRegion,
        slideDeckPublicKey,
      },
      tags,
      trackContext,
    };
    const initialRequest = makeRequest(postDuplicateRequest, requestParams);
    // Update request to workaround issues with property casing of the request body
    const updatedRequest = new Request(initialRequest.url, {
      method: initialRequest.method,
      headers: initialRequest.headers,
      body: JSON.stringify(requestParams),
    });
    const response = await fetch(updatedRequest);

    return postDuplicateResponse(response);
  });
};
